// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import catalogStyles from '../styles/institution-catalog.module.css';
import { InstitutionForm } from '@client/banks/components/shared/institution-form';
import { NavigationControls } from '@client/banks/layouts/navigation-controls';
import { ScreenLayout } from '@client/banks/layouts/screen-layout';
import { Button, Typography } from '@mui/material';
import { AppIcon } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { FormProvider } from 'react-hook-form';
import { useInstitutionManual } from './use-institution-manual';

export const InstitutionManual = defineComponent({
  displayName: 'InstitutionManual',
  useSetup: useInstitutionManual,
  View: ({ form, isFormValid, onSubmit, onSelectExisting }) => (
    <FormProvider {...form}>
      <ScreenLayout
        actions={
          <NavigationControls
            form="institution-manual-form"
            hidePrevious
            isFormValid={isFormValid}
            nextStep="accounts-list"
          />
        }
      >
        <div className={catalogStyles['step-body']}>
          <header className={catalogStyles['step-header']}>
            <Typography
              component="h2"
              variant="h6"
              className={catalogStyles['step-title']}
            >
              <Translation
                i18nKey="aggregator.create-bank.institution.title"
                ns="aggregator"
              />
            </Typography>
            <Typography
              variant="body2"
              className={catalogStyles['step-description']}
            >
              <Translation
                i18nKey="aggregator.create-bank.institution.manual-description"
                ns="aggregator"
              />
            </Typography>
          </header>

          <InstitutionForm formId="institution-manual-form" onSubmit={onSubmit} />

          <Button
            type="button"
            variant="outlined"
            color="secondary"
            fullWidth
            className={catalogStyles['alternate-action']}
            startIcon={<AppIcon icon="Landmark" size="lg" color="inherit" />}
            onClick={onSelectExisting}
            data-testid="bank-upload-institution-select-existing"
          >
            <Translation
              i18nKey="aggregator.create-bank.institution.back-to-catalog"
              ns="aggregator"
            />
          </Button>
        </div>
      </ScreenLayout>
    </FormProvider>
  ),
});
